import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from './instance'

export default class DataService {
  // 资产查看
  // 获取实体和实体类型的动态表数据  按 属性分组返回
  static async getClassAndClassTypeDynamicData(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassData/get-class-and-class-type-dynamic-data-by-group?${qs.stringify(
          payload
        )}`
      )
    )
    return Callback(err, res)
  }
  // 资产查看中获取Tabs列表
  static async getClassRelevancyDataClassList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.post(
        '/api/std/StructureBreakdown/get-class-relevancy-data-class-list',
        payload
      )
    )
    return Callback(err, res)
  }
  //  获取实体关联数据枚举列表
  static async getClassRelevancyDataType(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StructureBreakdown/get-class-relevancy-data-type?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取实体关联数据表头
  static async getClassRelevancyDataHeader(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.post(
        '/api/std/StructureBreakdown/get-class-relevancy-data-header',
        payload
      )
    )
    return Callback(err, res)
  }
  // 获取实体关联数据
  static async getClassRelevancyData(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StructureBreakdown/get-class-relevancy-data', payload)
    )
    return Callback(err, res)
  }
  // 搜索实体关联数据
  static async searchClassRelevancyData(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StructureBreakdown/search-class-relevancy-data', payload)
    )
    return Callback(err, res)
  }
  // 资产目录树
  // 获取实体和实体类型的下拉数据
  static async getClassAndClassTypeDropDowData(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClass/get-class-and-class-type-drop-dow-data', payload)
    )
    return Callback(err, res)
  }
  // 获取实体属性和实体类型属性的下拉数据
  static async getClassAndClassTypeAttrDropDowData(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.post(
        '/api/std/StdClass/get-class-and-class-type-attr-drop-dow-data ',
        payload
      )
    )
    return Callback(err, res)
  }
  // 获取实体和实体类型的属性列表（资产目录树新增时使用）
  static async getClassAndClassTypeAttrList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClass/get-class-and-class-type-attribute-list', payload)
    )
    return Callback(err, res)
  }
  // 获取实体归集(分页接口)
  static async getStdClassNotionalpooling(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassNotionalpooling/get_list', payload)
    )
    return Callback(err, res)
  }
  // 获取资产列表（根据操作符获取实体和实体类型 的动态数据）
  static async getTreeList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      // wizStandardInstance.post('/api/std/StructureBreakdown/get_data_by_tree', payload)
      wizStandardInstance.post(
        '/api/std/StructureBreakdown/get-class-and-class-type-dynamic-data',
        payload
      )
    )
    return Callback(err, res)
  }
  // 获取资产列表（ 获取实体数据 通过目录树）
  static async getClassDataByTree(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StructureBreakdown/get-class-data-by-tree', payload)
    )
    return Callback(err, res)
  }
  // 资产目录树配置
  // 资产目录树tree的第一层数据
  static async getFirstTreeById(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      // wizStandardInstance.get(
      //   `/api/std/StructureBreakdown/get_first_tree_node?${qs.stringify(payload)}`
      // )
      wizStandardInstance.post('api/std/StructureBreakdown/get_first_tree_node_new', payload)
    )
    return Callback(err, res)
  }
  // 资产目录树tree的懒加载数据
  static async getLazyTreeDatas(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      // wizStandardInstance.post('/api/std/StructureBreakdown/get_next_tree_node', payload)
      wizStandardInstance.post('/api/std/StructureBreakdown/get_next_tree_node_new', payload)
    )
    return Callback(err, res)
  }
  // 获取资产目录树的树结构的树切换种类列表
  static async getTreeKinds(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StructureBreakdown?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取标准下拉列表数据
  static async getStdStandardList() {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get('/api/std/StdStandard/get_select_stdstandard')
    )
    return Callback(err, res)
  }
  // 根据标准id获取实体下拉列表数据
  static async getClassList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass/query_class_by_standard?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 根据实体id获取展开属性下拉列表数据
  static async getOpenAtrrOptions(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassAttribute/get_classattribute_by_classid?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 根据属性ID获取显示属性列表和引用实体信息【资产目录树配置用（引用实体和显示属性下拉框）】
  static async getDisplayAtrrOptions(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassAttribute/get_displayattribute_by_id?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 目录结构树配置- 保存实体
  static async addTreeKinds(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StructureBreakdown', payload))
    return Callback(err, res)
  }
  // 目录结构树配置- 编辑实体
  static async updateTreeKinds(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(wizStandardInstance.patch('/api/std/StructureBreakdown', payload))
    return Callback(err, res)
  }
  // 目录结构树配置- 删除实体
  static async deleteTreeKinds(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(wizStandardInstance.delete('/api/std/StructureBreakdown', payload))
    return Callback(err, res)
  }
  // 获取资产目录树资产查看的基本属性【类别类型模板属性+拓展属性】
  static async getDatabaseAttribute(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StructureBreakdown/get_database_attribute?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取资产查看的所有关联表信息
  static async getAssetsTableList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StructureBreakdown/get_assets_table_list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取动态关联表数据
  static async getAssetsTableData(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StructureBreakdown/get_assets_table_data?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取关联关系
  static async getRelationData(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      // wizStandardInstance.get(
      //   `/api/std/StructureBreakdown/get_class_relation?${qs.stringify(payload)}`
      // )
      wizStandardInstance.post('/api/std/StructureBreakdown/get-class-relation', payload)
    )
    return Callback(err, res)
  }
  // 添加关联关系图节点和线
  static async addClassRelation(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StructureBreakdown/add_class_relation?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取大数据实时测点数据
  static async getWizData(payload) {
    const [err, res] = await To(wizRealTimeDataInstance.post('/iot/getRuntimeValue', payload))
    return Callback(err, res)
  }
  // 上传文件
  static async uploadFile(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/upload', payload.reqData, {
        'Content-Type': 'multipart/form-data',
      })
    )
    return Callback(err, res)
  }
  // 获取当前记录的文件（传当前记录的id）
  static async getFileId(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/files?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 文件浏览（PDF)（传fileId）
  static async browsePDF(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/browse?${qs.stringify(payload)}`, {
        responseType: 'arraybuffer',
      })
    )
    return Callback(err, res)
  }
  // 文件浏览（PNG)（传fileId）
  static async browsePNG(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/browse?${qs.stringify(payload)}`, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 删除文件
  static async deleteFile(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete(`/api/std/StdClassData/delete-file?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 更新属性记录
  static async updateAttrData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/update_data_detail', payload)
    )
    return Callback(err, res)
  }
  // 获取属性记录
  static async findAttrData(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/get_data_by_id?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取操作符
  static async getSearchOperator(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        // `/api/std/StructureBreakdown/get_search_operator?${qs.stringify(payload)}`
        `/api/std/StdClassData/get-operator-enum-list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取业务数据类型
  static async getDataKind(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StructureBreakdown/data-kind?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 主数据清单（右侧动态表格）
  static async getClassDataByMasterData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StructureBreakdown/get-class-data-by-master-data', payload)
    )
    return Callback(err, res)
  }
  // 下载主数据
  static async downloadMasterData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StructureBreakdown/download-master-data', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 获取实体类型是文档的实体
  static async getTypeClass(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass/get-type-class?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
}
